import { render } from "./tag.vue?vue&type=template&id=6c372f69&scoped=true"
const script = {}

import "./tag.vue?vue&type=style&index=0&id=6c372f69&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c372f69"]])

export default __exports__